import {Loader2Icon, UserRoundIcon} from "lucide-react";
import {Character, CharacterSummary} from "@/characters/model/Character.ts";
import {getCharacterById, searchCharacters} from "@/api/CharacterApi.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import SearchPopover, {HighlightedSearchText} from "@/search/SearchPopover.tsx";
import {formatChallengeRating, getStyleColor} from "@/characters/model/ChallengeRating.ts";
import {cn} from "@/lib/utils.ts";

export default function CharacterSearchView({addCharacter}: { addCharacter: (character: Character) => void }) {
    return <SearchPopover<CharacterSummary>
        placeholder="Charakter suchen"
        minQueryLength={1}
        className="w-full"
        search={(query, signal) => searchCharacters({page: 0, size: 15}, {name: query}, signal)}
        getKey={character => character.id}
        onSelect={async character => addCharacter(await getCharacterById(character.id))}
        renderItem={({item: character, query, select, selecting}) => {
            const color = getStyleColor(character);
            return <button type="button" disabled={selecting}
                           className={cn(
                               "flex w-full items-center gap-3 border-l-4 bg-popover px-2 py-1.5 text-left transition-colors hover:bg-accent/70 disabled:opacity-60",
                               character.hostile ? "border-l-red-500" : "border-l-emerald-500",
                           )}
                           onClick={select}>
                <span
                    className={cn("flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-sm border bg-white", color.border)}>
                    {character.image
                        ? <img className="size-full object-contain" alt="" src={srcUrl(character.image)}/>
                        : <UserRoundIcon className="size-5"/>}
                </span>
                <span className="min-w-0 grow">
                    <span className="block truncate font-semibold"><HighlightedSearchText text={character.name}
                                                                                          query={query}/></span>
                    <span className="mt-0.5 flex flex-wrap items-center gap-x-1.5 text-xs text-muted-foreground">
                        <span className={color.text}>{character.hostile ? "Feindlich" : "Freundlich"}</span>
                        <span aria-hidden="true" className="text-border">•</span>
                        <span>HG {formatChallengeRating(character)}</span>
                        <span aria-hidden="true" className="text-border">•</span>
                        <span>{character.hitPoints} TP</span>
                    </span>
                </span>
                {selecting && <Loader2Icon className="mr-1 size-4 animate-spin"/>}
            </button>;
        }}
    />;
}
